import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, GuardResult, Router, RouterStateSnapshot } from '@angular/router';

import { UserExperienceService } from '@services/user-experience.service';
import { SummitDisposing } from '@summit/models';

@Injectable()
export class LoginGuard extends SummitDisposing implements CanActivate {
  constructor(
    private router: Router,
    private uxService: UserExperienceService
  ) {
    super();
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): GuardResult {
    const isLoggedIn = this.uxService.getUserExperience().isLoggedIn();

    if (isLoggedIn) {
      // logged in so return true
      // this.router.navigateByUrl([_route._routeState.url]);
      if (state.url?.startsWith('/login')) {
        if (route.queryParams['returnUrl']) {
          const urlTree = this.router.parseUrl(route.queryParams['returnUrl']);
          return urlTree;
        } else {
          return this.router.parseUrl('/dashboard');
        }
      }
      return true;
    }
    // Allow anonymous access to these paths
    if (
      state.url?.startsWith('/login') ||
      state.url?.startsWith('/signup') ||
      state.url?.startsWith('/accounts/resetpassword') ||
      state.url?.startsWith('/updates') ||
      state.url?.startsWith('/about')
    ) {
      return true;
    }
    const returnUrl = state.url;
    const newRoute = this.router.parseUrl('/login');
    newRoute.queryParams = { returnUrl: returnUrl };
    return newRoute;
  }
}
